/**
 * @flow
 * @relayHash 35d8e259ac7499f4c325326c6f63f825
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BrokenHreflangIssuesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type BrokenHreflangIssuesTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  sourceUrl?: ?TextFilters,
  url?: ?TextFilters,
|};
export type BrokenHreflangIssuesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: BrokenHreflangIssuesTable_project$ref
  |}
|};
export type BrokenHreflangIssuesTable_RefetchQuery = {|
  variables: BrokenHreflangIssuesTable_RefetchQueryVariables,
  response: BrokenHreflangIssuesTable_RefetchQueryResponse,
|};
*/


/*
query BrokenHreflangIssuesTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $sourceUrl: TextFilters
  $url: TextFilters
) {
  project(host: $host) {
    ...BrokenHreflangIssuesTable_project_YfUe9
    id
  }
}

fragment BrokenHreflangIssuesTable_project_YfUe9 on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        brokenHreflangs(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl) {
          count
          edges {
            node {
              ...BrokenHreflangIssuesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment BrokenHreflangIssuesRow_issue on BrokenHreflang {
  id
  type
  severity
  url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "BrokenHreflangIssuesTable_RefetchQuery",
  "id": null,
  "text": "query BrokenHreflangIssuesTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $sourceUrl: TextFilters\n  $url: TextFilters\n) {\n  project(host: $host) {\n    ...BrokenHreflangIssuesTable_project_YfUe9\n    id\n  }\n}\n\nfragment BrokenHreflangIssuesTable_project_YfUe9 on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        brokenHreflangs(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl) {\n          count\n          edges {\n            node {\n              ...BrokenHreflangIssuesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment BrokenHreflangIssuesRow_issue on BrokenHreflang {\n  id\n  type\n  severity\n  url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BrokenHreflangIssuesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BrokenHreflangIssuesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BrokenHreflangIssuesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokenHreflangs",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "sourceUrl",
                            "variableName": "sourceUrl",
                            "type": "TextFilters"
                          },
                          {
                            "kind": "Variable",
                            "name": "url",
                            "variableName": "url",
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "BrokenHreflangConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokenHreflangEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokenHreflang",
                                "plural": false,
                                "selections": [
                                  v2,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '383af90a8066943413d62a4d1df25bda';
module.exports = node;
